import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import { Translate, I18n } from "react-redux-i18n";
import { getXsrfToken } from "../../Store/Security/Actions";
import { changePassword } from "../../Store/Account/Actions";
import { toggleBlockingStatus } from "../../Store/Status/Actions";

class CustomerChangePassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            receivedSuccessfulResponse: false
        };

        this.renderTextField = this.renderTextField.bind(this);
    }

    renderTextField(field) {
        const { meta: { touched, error }, size, label, type, input } = field;
        const className = `col-${size} ${touched && error ? "has-error" : ""}`;

        return (
            <div className={className}>
                <label><Translate value={label} />:</label>
                <input type={type} {...input} />
                <span className="help-block float-left">{touched ? error : ""}</span>
            </div>
        );
    }

    renderErrors() {
        if (this.props.changePasswordStatus.response) {
            const { response: { data } } = this.props.changePasswordStatus;
            if (data) {
                this.props.toggleBlockingStatus(false);

                return (
                    <div className="col-md-12">
                        <div className="alert bg--error" style={{ marginBottom: 0 }}>
                            <div className="alert__body">
                                <span>{data}</span>
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    onSubmit(values) {
        const { getXsrfToken, changePassword } = this.props;

        getXsrfToken(({ token }) => {
            const obj = {
                ...values,
                __RequestVerificationToken: token
            };

            changePassword(obj, () => {
                toggleBlockingStatus(false);
                this.setState({ receivedSuccessfulResponse: true });
            });
        });
    }

    render() {
        const { handleSubmit, submitting } = this.props;
        const { receivedSuccessfulResponse } = this.state;

        return (
            <div id="account-password" className="account-tab">
                <h4><Translate value="profile.changePassword.title" /></h4>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <div className="row">
                        <Field
                            name="OldPassword"
                            type="password"
                            label="profile.changePassword.oldPassword"
                            size="12"
                            component={this.renderTextField}
                        />
                        <Field
                            name="NewPassword"
                            type="password"
                            label="profile.changePassword.newPassword"
                            size="md-6"
                            component={this.renderTextField}
                        />
                        <Field
                            name="ConfirmNewPassword"
                            type="password"
                            label="profile.changePassword.confirmPassword"
                            size="md-6"
                            component={this.renderTextField}
                        />
                    </div>
                    <div className="row">
                        {this.renderErrors()}
                        <div className="col-lg-4">
                            <button type="submit" className="btn btn--primary type--uppercase" disabled={submitting}><Translate value="profile.changePassword.save" /></button>
                        </div>
                    </div>
                    {receivedSuccessfulResponse &&
                        <div className="row">
                            <div className="col-lg-4">
                                <label><Translate value="passwordReset.success.title" /></label>
                            </div>
                        </div>
                    }
                </form>
            </div>
        );
    }
}

CustomerChangePassword.propTypes = {
    handleSubmit: PropTypes.func,
    getXsrfToken: PropTypes.func,
    toggleBlockingStatus: PropTypes.func,
    submitting: PropTypes.bool,
    i18n: PropTypes.object,
    config: PropTypes.object,
    changePasswordStatus: PropTypes.object
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        changePasswordStatus: state.changePasswordStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken,
        changePassword,
        toggleBlockingStatus
    }, dispatch);
}

function validate(values) {
    const errors = {};

    if (!values.OldPassword) {
        errors.OldPassword = I18n.t("validation.profile.changePassword.oldPassword.required");
    }
    if (!values.NewPassword) {
        errors.NewPassword = I18n.t("validation.profile.changePassword.newPassword.required");
    }
    if (!values.ConfirmNewPassword) {
        errors.ConfirmNewPassword = I18n.t("validation.profile.changePassword.confirmNewPassword.required");
    }
    if (values.NewPassword && values.ConfirmNewPassword && values.NewPassword !== values.ConfirmNewPassword) {
        errors.ConfirmNewPassword = I18n.t("validation.profile.changePassword.confirmNewPassword.match");
    }

    return errors;
}

export default reduxForm({
    validate,
    form: "ChangePassword"
})(
    connect(mapStateToProps, mapDispatchToProps)(CustomerChangePassword)
);
